export enum UserActivityType {
  DOWNLOADED_LIBRARY_FILE = 'downloaded_library_file',
  PREVIEWED_LIBRARY_FILE = 'previewed_library_file',
  USER_START_WATCHING_VIDEO = 'user_start_watching_video',
  USER_WATCHED_VIDEO = 'user_watched_video'
}
